import { render, staticRenderFns } from "./DZSVG.vue?vue&type=template&id=49e90d4e&scoped=true"
import script from "./DZSVG.vue?vue&type=script&lang=js"
export * from "./DZSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e90d4e",
  null
  
)

export default component.exports